import { render, staticRenderFns } from "./InternalLink.vue?vue&type=template&id=b87433aa&"
import script from "./InternalLink.vue?vue&type=script&lang=js&"
export * from "./InternalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports